import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon } from 'lucide-react';
export function Proof() {
  return <section className="bg-off-white py-16 px-6" data-id="element-160">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-161">
        <div className="bg-white p-8 md:p-12 rounded-lg shadow-xl border-l-4 border-gold" data-id="element-162">
          <div className="flex items-start gap-4 mb-6" data-id="element-163">
            <TrendingUpIcon className="w-12 h-12 text-gold flex-shrink-0" data-id="element-164" />
            <h2 className="font-serif text-3xl md:text-4xl text-navy" data-id="element-165">
              Qué Cambia en Tus{' '}
              <span className="text-gold" data-id="element-166">Primeros 7 Días</span>
            </h2>
          </div>
          <p className="text-lg text-gray-800 leading-relaxed" data-id="element-167">
            Pasarás de la incertidumbre total a tener un{' '}
            <strong data-id="element-168">inventario financiero claro</strong>, un{' '}
            <strong data-id="element-169">CV que realmente genera llamadas</strong> y la{' '}
            <strong data-id="element-170">confianza de saber que no te estafaron</strong> en tu
            liquidación. El conocimiento es el único antídoto contra el pánico.
          </p>
        </div>
      </motion.div>
    </section>;
}